<style>
    @import "./vip.less";
</style>
<template>
    <div class="lawtelephone">
        <div class="lawt_con">
        </div>
        <div class="lawt_fr_content">
            <img src="./lawcomponent/images/lawContrant1.png"/>
            <div class="lawt_fr_content_rig">
                <p class="rg_title">合同审核</p>
                <p class="rg_tw_title">由专业律师提供各类合同的审核服务，单份合同限5000字以内</p>
                <div style="margin-top:40px;">
                    <p class="rg_tw_title">请选择类型:</p>
                    <div style="margin-top:15px;">
                        <input @click="contractTypeValue = item.value" v-for="(item,index) in contractType"
                               :class="item.value == contractTypeValue ? 'active' : '' " type="button"
                               :value="item.name"/>
                    </div>
                </div>
                <p v-if="lawyerConsultNum>0" class="vipstyle">您是{{ userInfo.accountType == 'person' ? '个人' : '企业'
                    }}VIP会员，当前剩余{{lawyerConsultNum}}次法律服务</p>
                <input class="goOrderEsc" @click="oneSubmit" type="button" value="立即下单"/>
            </div>
        </div>
        <div class="lawt_parcontent" style="margin-bottom:80px">
            <div class="lawt_cont_title">
                <div>您可能还需要以下服务</div>
            </div>
            <div style="padding-top:339px">
                <lawCommon active-id="2"/>
            </div>
        </div>
        <div class="lawContract_four">
            <div class="lawContract_four_content">
                <div class="th_thcontent">
                    <div class="tongyong_top">
                        <p>合同审核的重要性</p>
                        <div></div>
                    </div>
                    <div class="lawContractleft">
                        <p><span class="span-line"></span>白纸黑字</p>
                        <p style="margin-bottom:40px;">明确双方权益和责任，避免口头承诺无法实现</p>
                    </div>
                    <div class="lawContractleft">
                        <p><span class="span-line"></span>呈堂证供</p>
                        <p>一旦产生纠纷，签过字的合同课作为法庭上的证据</p>
                    </div>
                </div>
                <img style="margin-right:17px;" src="./lawcomponent/images/lawContrant3.png"/>
                <p class="th_title">C<br/>O<br/>N<br/>T<br/>R<br/>A<br/>C<br/>T</p>
            </div>
        </div>
        <div class="lawJudgement_three">
            <div class="law_thre_content">
                <p class="th_title">C<br/>O<br/>P<br/>Y<br/>R<br/>I<br/>G<br/>H<br/>T</p>
                <img src="./lawcomponent/images/lawjudge1.png"/>
                <div class="th_thcontent">
                    <img style="margin-top:60px;" src="./lawcomponent/images/lawjudge5.png"/>
                    <p style="margin-top:30px;" class="th_pf">根据《著作权法》第48条的规定</p>
                    <p style="margin-top:30px;" class="th_ps">侵犯著作权，侵权人应当按照权利人的实际损失给予赔偿</p>
                    <p style="margin-top:15px;margin-bottom:15px;" class="th_ps">实际损失难以计算的，不能确定的，由人民法院根据侵权行为</p>
                    <p class="th_ps">的情节，判决给予50万元以下的赔偿。</p>
                </div>
            </div>
        </div>
        
        <div class="lawtbo_content" style="padding-top:53px;padding-bottom:50px">
            <lawcommontw :content="content" :title="title"/>
            <img src="./lawcomponent/images/lawtele1.png"/>
        </div>

        <!--    合同审核模态框    -->
        <generalframe @fatherMethod="fatherMethod" v-show="showDialog" myheight="428" maintitle="合同审核" ref="mychild">
            <div class="ts_content">
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p>接听手机：</p>
                    <input v-model="callbackMobilePhone" style="flex:1" type="text" maxLength="11"
                           placeholder="请输入11位手机号码"/>
                </div>
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p>上传合同：</p>
                    <Upload
                            ref="upload"
                            :show-upload-list="false"
                            :on-success="handleSuccess"
                            :on-format-error="handleFormatError"
                            :on-exceeded-size="handleMaxSize"
                            :before-upload="handleBeforeUpload"
                            :multiple="false"
                            type="drag"
                            action=""
                            style="display: inline-block;">
                        <i-button icon="ios-cloud-upload-outline">选择文件</i-button>
                    </Upload>
                    <div :title="fileName" class="shoetext" v-model="contractUrl">{{fileName}}</div>
                    <input style="flex:1;display:none;" type="text" placeholder="请输入下架链接"/>
                </div>
                <div class="ts_content_fr">
                    <p>描述：</p>
                    <textarea v-model="questionDesc"
                              style="flex:1;min-height:120px;resize: none;padding: 5px;"
                              placeholder="请输入您需要判定的简要描述"></textarea>
                </div>
                <input class="goOrderEsc" @click="sureOrder" type="button" value="确认下单"/>
            </div>
        </generalframe>
        <!--    加油包    -->
        <monitorBag bizType="05" v-if="monitorBagState" @monitorBagFather="monitorBagFuc"/>
        <!--    会员续费    -->
        <myczPay v-if="myczPayState" mywidth='838' myheight="585" myTitleheight="50" @fatherModal="myczPayFuc"/>
    </div>
</template>
<script>
    import lawcommontw from './lawcomponent/lawcomponenttw.vue'
    import lawCommon from './lawcomponent/lawcomponentbl.vue'
    import generalframe from './lawcomponent/generalframe.vue'
    import monitorBag from '@/views/vipClip/monitor/components/monitorBag';
    import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay'
    import Cookies from "js-cookie";
    import {getHuaWeiToken, getContractAudit, getVipMemberright} from '@/api/staticPage';
    import util from '@/libs/util';

    // import OBS from 'huawei-obs';
    const documnetType = 20971520;
    const HWC_KEY = "https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar"
    const type = ['bat', 'exe', 'com', 'DLL', 'MSI', 'VBS', 'VBE', 'JS', 'JSE', 'WSH', 'WSF', 'PBD', 'PB', 'dmg', 'fcd', 'gdb', 'REG', 'SAV', 'str', 'SYS', 'swf', 'VBP', 'VBW', 'VBX', 'VIR', 'VXD', 'WCM', 'WIZ', 'A', 'ADF'];
    const reImg = /^(bmp|png|jpg|gif|jpeg)$/;
    const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
    const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
    const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;
    String.prototype.suffix = function () {
        var index1 = this.lastIndexOf(".");
        var index2 = this.length;
        return this.substring(index1 + 1, index2)
    }
    var globalContext = {};
    globalContext.maxTaskNum = 5;
    globalContext.currentTaskNum = 0;

    const _doUpload = (obsClient, uploadPartStatus) => new Promise((res, rej) => {
        var events = require('events');
        var allDoneEe = new events.EventEmitter();
        doUploadPart(obsClient, uploadPartStatus, allDoneEe);
        allDoneEe.on('upload part finished', (result, _parts) => {
            res(result, _parts);
        });

        allDoneEe.on('error', (err) => {
            rej(err);
        });
    });

    const doUploadPart = (obsClient, uploadPartStatus, allDoneEe) => {
        while (uploadPartStatus.currentPartIndex < uploadPartStatus.partCount && globalContext.currentTaskNum < globalContext.maxTaskNum) {
            var offset = uploadPartStatus.currentPartIndex * uploadPartStatus.partSize;
            var currPartSize = (uploadPartStatus.currentPartIndex + 1 === uploadPartStatus.partCount) ? uploadPartStatus.fileSize - offset : uploadPartStatus.partSize;
            var partNumber = uploadPartStatus.currentPartIndex + 1;
            uploadPartStatus.currentPartIndex++;
            globalContext.currentTaskNum++;

            var getCallback = function (partNumber) {
                return function (result) {
                    globalContext.currentTaskNum--;
                    doUploadPart(obsClient, uploadPartStatus, allDoneEe);
                    if (result.CommonMsg.Status < 300) {
                        console.log('Part:' + partNumber + ' finished, etag:' + result.InterfaceResult.ETag);
                        uploadPartStatus.parts.push({PartNumber: partNumber, ETag: result.InterfaceResult.ETag});
                        if (uploadPartStatus.parts.length === uploadPartStatus.partCount) {
                            var _parts = uploadPartStatus.parts.sort(function (a, b) {
                                if (a.PartNumber >= b.PartNumber) {
                                    return 1;
                                }
                                return -1;
                            });
                            obsClient.completeMultipartUpload({
                                Bucket: uploadPartStatus.bucketName,
                                Key: uploadPartStatus.objectKey,
                                UploadId: uploadPartStatus.uploadId,
                                Parts: _parts
                            }, function (err, result) {
                                if (!err && result.CommonMsg.Status < 300) {
                                    console.log('Complete to upload multiparts finished.\n');
                                    allDoneEe.emit('upload part finished', result, _parts);
                                } else {
                                    var msg = err || result.CommonMsg.Code;
                                    console.error(msg);
                                    allDoneEe.emit('error', msg);
                                }
                            });
                        }
                    } else {
                        console.error(result.CommonMsg.Code);
                        allDoneEe.emit('error', result.CommonMsg.Code);
                    }
                }
            };

            obsClient.uploadPart({
                Bucket: uploadPartStatus.bucketName,
                Key: uploadPartStatus.objectKey,
                PartNumber: partNumber,
                UploadId: uploadPartStatus.uploadId,
                SourceFile: uploadPartStatus.file,
                Offset: offset,
                PartSize: currPartSize
            }).then(getCallback(partNumber)).catch(function (err) {
                console.error('err:' + err);
                allDoneEe.emit('error', err);
            });
        }
    };
    export default {
        metaInfo: {
            title: '合同审核|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            }, {
                name: 'Description',
                content: ''
            }]
        },
        name: 'lawContract',
        components: {
            lawcommontw,
            lawCommon,
            generalframe,
            monitorBag,
            myczPay
        },
        data() {
            return {
                userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                contractType: [
                    {name: '合同审核', value: 'contract_audit'},
                    {name: '代写合同', value: 'contract_ghostwrite'}
                ], //合同审核类型
                contractTypeValue: 'contract_audit', //合同审核类型值
                content: [
                    {content: '预约律师，确认下单', english: 'ONE'},
                    {content: '等待律师，电话联系', english: 'TWO'},
                    {content: '双方沟通，解答问题', english: 'THREE'},
                    {content: '服务完成，平台回访', english: 'FOUR'},
                ],
                title: '律师服务流程',
                records: [
                    {
                        content: '一次付费咨询可以通话多久？',
                        reContent: '通话时长应控制在30分钟以内，如超出时间，律师课选择结束咨询。'
                    },
                    {
                        content: '下单后谁会联系我？',
                        reContent: '下单后，律师会给您回电话，我们要求律师在20分钟内响应。'
                    },
                    {
                        content: '律师超时未联系怎么办？',
                        reContent: '有时律师可能因为开庭等事项无法及时响应，如果超时未响应，请联系平台客服，版权家客服经理会为您协调更换律师。'
                    },
                    {
                        content: '咨询律师前需要准备什么？',
                        reContent: '为了高效利用您的咨询时间，请在下单前尽可能把您需要准备的问题梳理清楚。'
                    },
                    {
                        content: '和律师沟通后，有意向委托律师服务，该怎么办？',
                        reContent: '如果是合同、侵权下架等平台已有的服务，您可以直接在平台下单即可，如果平台上没有的产品您可以联系平台客服，平台客服经理会为您安排。'
                    },
                ],
                showDialog: !1,
                questionDesc: '',
                callbackMobilePhone: '',
                contractUrl: '',
                uploadList: [],
                accessKeyId: '',
                accessKeySecret: '',
                stsToken: '',
                md5Hash: '',
                fileName: '',
                lawyerConsultNum:0, //法律服务次数
                monitorBagState: false, //加油包模态框展示状态
                myczPayState: false //会员监测模态框展示状态
            }
        },
        methods: {
            _getContractAudit() {
                let _this = this;
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                let params = {
                    registerId: userInfo && userInfo.id ? userInfo.id : '',
                    callbackMobilePhone: _this.callbackMobilePhone,
                    questionDesc: _this.questionDesc,
                    contractUrl: _this.contractUrl,
                    contractType: _this.contractTypeValue
                };
                getContractAudit(params).then(res => {
                    //1.用户未实名；2.VIP未开通；3.VIP已到期；4.加油包

                    switch (res.code) {
                        case 200 : {
                            _this.lawyerConsultNum = _this.lawyerConsultNum - 1;
                            _this.fatherMethod();
                            toast('提交成功！请前往【个人中心】查看订单服务详情');
                            break;
                        }
                        //未开通VIP
                        case 214: {
                          toast("请购买产品后使用")
                          this.$router.push('/goods')
                          break;
                        }
                        //VIP已到期--弹框
                        case 215: {
                            /*toast(message, () => {
                                this.myczPayState = true;
                            });*/
                            toast("请购买产品后使用")
                            this.$router.push('/goods')
                            break;
                        }

                        //次数不够--弹出加油包
                        case 216 : {
                            this.monitorBagState = true;
                            break;
                        }

                        default:
                            toast(message);
                            break;

                    }


                }, (err) => {
                    toast('提交失败，请重试');
                })
            },

            /************服务次数接口***********/
            _getVipMemberright() {
                let _this = this;
                let userInfo = this.userInfo;

                if(userInfo && userInfo!='' && userInfo.vipFlag!=0){
                    let params = {
                        registerId: userInfo && userInfo.id ? userInfo.id : '',
                    };
                    getVipMemberright(params).then(res => {
                        if (res.code == 200) {
                            this.lawyerConsultNum = res.result.lawyerConsultNum;
                        }
                    })
                }

            },

            goOrder() {
                let _this = this;
                _this.showDialog = !0
            },

            fatherMethod() {
                let _this = this;
                _this.showDialog = !1;
                _this.callbackMobilePhone = '';
                _this.questionDesc = '';
                _this.contractUrl = '';
                _this.fileName = '';
            },
            sureOrder() {
                let _this = this;
                if (!util.checkPhoneNum(_this.callbackMobilePhone)) {
                    toast('请填写正确的手机号再提交');
                } else if (_this.questionDesc == '' || _this.contractUrl == '') {
                    toast('请填写完整后再提交');
                } else {
                    _this._getContractAudit()
                }

            },
            handleSuccess(res, file) {
                file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
                file.name = '7eb99afb9d5f317c912f08b5212fd69a';
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: 'The file format is incorrect',
                    desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
                });
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: '超出单个存证对文件最大限制',
                    desc: '超出单个存证对文件最大限制, 所有类型累计不能超过820M.'
                });
            },
            handleBeforeUpload: async function (file) {
                await this._getHuaWeiToken();
                console.log('111111111111111111')
                var tempdocument = 0;
                var temppicture = 0;
                var tempmv = 0;
                var tempother = 0;
                let _this = this
                console.log("获取到的file文件", file, this.uploadList)

                var filetype = file.name.suffix()
                if (file.size > documnetType) {
                    this.$Notice.warning({
                        title: '超出最大允许上传上线',
                        desc: '文件上传不能不超过20M'
                    });
                    return false;
                }
                let fileReader = new FileReader(),
                    blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
                    chunkSize = 2097152,
                    chunks = Math.ceil(file.size / chunkSize),
                    currentChunk = 0,
                    spark = new SparkMD5.ArrayBuffer();
                const loadNext = () => {
                    var start = currentChunk * chunkSize,
                        end = start + chunkSize >= file.size ? file.size : start + chunkSize;
                    fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
                };
                loadNext();
                fileReader.onload = (e) => {
                    spark.append(e.target.result);
                    currentChunk++;
                    if (currentChunk < chunks) {
                        loadNext();
                    } else {
                        this.md5Hash = spark.end();
                        var mdfives = this.md5Hash
                        if (this.md5Hash != '') {
                            var partSize = 2097152;
                            var fileSize = file.size;
                            console.log('+++++++++++++++++++++++++', _this.accessKeyId, _this.accessKeySecret, _this.stsToken)
                            var obsClient = _this.getObsClient();
                            obsClient.initiateMultipartUpload({
                                Bucket: "anne-bqj-file1",
                                Key: "file/" + mdfives + "." + file.name.substring(file.name.lastIndexOf(".") + 1)
                                // Key:"file/" + file.name
                            }).then(function (result) {
                                console.log('4最终获取到华为云obs的结果', result)
                                var uploadId = result.InterfaceResult.UploadId;
                                console.log('uploadId:' + uploadId);
                                var partCount = fileSize % partSize === 0 ? Math.floor(fileSize / partSize) : Math.floor(fileSize / partSize) + 1;
                                console.log('partCount:' + partCount);
                                var uploadPartStatus = {
                                    bucketName: "anne-bqj-file1",
                                    objectKey: result.InterfaceResult.Key,
                                    uploadId: uploadId,
                                    file: file,
                                    fileSize: fileSize,
                                    partSize: partSize,
                                    partCount: partCount,
                                    currentPartIndex: 0,
                                    parts: []
                                };
                                _doUpload(obsClient, uploadPartStatus).then((doneResult, _parts) => {
                                    console.log(`done signal is: ${doneResult}, ${_parts}`);
                                    let layout = uploadPartStatus.objectKey.substring(uploadPartStatus.objectKey.lastIndexOf(".") + 1);
                                    // _this.uploadList = [{
                                    //     uid: file.uid,
                                    //     name: file.name,
                                    //     status: 'done',
                                    //     type: file.type,
                                    //     md5Hash:mdfives,
                                    //     url:'http://file.bqj.cn/'+result.InterfaceResult.Key,
                                    //     result:HWC_KEY + result.InterfaceResult.Key,
                                    // }]
                                    _this.fileName = file.name;
                                    _this.contractUrl = 'http://file.bqj.cn/' + result.InterfaceResult.Key;
                                    return false;
                                }).catch(e => {
                                    console.error(e);
                                });
                            }).catch(e => {
                                console.error(e);
                            });
                        }
                    }
                }
                // this.getObsClient()
            },
            _getHuaWeiToken: async function () {
                await getHuaWeiToken().then((res) => {
                    console.log('获取的华为云的临时cookie', res)
                    if (res.code == 200) {
                        this.accessKeyId = res.result.accessKeyId;
                        this.accessKeySecret = res.result.accessKeySecret;
                        this.stsToken = res.result.securityToken;
                    }
                })
            },
            getObsClient() {
                let _this = this
                var obsClient = new window.ObsClient({
                    access_key_id: _this.accessKeyId,
                    secret_access_key: _this.accessKeySecret,
                    security_token: _this.stsToken,
                    server: "obs.cn-north-4.myhuaweicloud.com",
                    timeout: 60 * 5,
                })
                return obsClient;
            },

            /****************接收加油包组件传值**************/
            monitorBagFuc(value) {
                this.monitorBagState = false;
            },


            /****************接收会员续费组件传值**************/
            myczPayFuc() {
                console.log('会员续费弹框');
                this.myczPayState = false;
            },

            oneSubmit() {
                let userInfo = this.userInfo;
                console.log(userInfo);
                if (!userInfo || userInfo == '') {
                    toast('请登录后再提交', () => {
                        this.$router.push({
                            path: '/'
                        });
                    });
                    return
                } else if (this.contractTypeValue == '') {
                    console.log(this.contractTypeValue);
                    toast('请选择完整后提交')
                } else {
                    this.goOrder();
                }
            }
        },
        mounted() {
            this._getVipMemberright();
        }
    }
</script>
<style scoped lang="less">
    .lawtelephone {
        .lawt_con {
            height:360px;
            width: 100%;
            background:#121210;
        }

        .lawt_fr_content {
            width: 1334px;
            height: 518px;
            background: rgba(255, 255, 255, 1);
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            margin-top: -280px;
            z-index: 555;
            display: flex;
            justify-content: flex-start;
            img {
                width: 506px;
                height: 360px;
                display: block;
                margin: 32px 0 0 30px;
            }

            .lawt_fr_content_rig {
                margin-left: 37px;

                .rg_title {
                    height: 28px;
                    font-size: 20px;
                    font-weight: bold;
                    color: rgba(65, 65, 65, 1);
                    line-height: 28px;
                    margin-top: 40px;
                }

                .rg_tw_title {
                    height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(65, 65, 65, 1);
                    line-height: 20px;
                }

                input {
                    width:137px;
                    height:42px;
                    background:rgba(255,255,255,1);
                    border-radius:2px;
                    border:1px solid rgba(199,199,199,1);
                    font-size: 14px;
                    font-weight: 400;
                    color:rgba(51,51,51,0.6);
                    line-height: 42px;
                    cursor: pointer;
                    outline: none;
                    margin-right: 20px;

                    &:hover {
                        border:1px solid rgba(18,18,16,1);
                        color:rgba(51,51,51,1);
                    }

                    &.goOrderEsc:hover {
                        border:none;
                        color:rgba(255,255,255,1);
                    }
                }

                .active {
                    border:1px solid rgba(18,18,16,1);
                    color:rgba(51,51,51,1);
                }

                .vipstyle {
                    height: 20px;
                    font-size: 14px;
                    font-weight:400;
                    color:rgba(232,46,49,1);
                    line-height: 20px;
                    margin-top: 93px;
                }

                .goOrderEsc {
                    margin-top: 20px;
                    width:182px;
                    height:52px;
                    background:rgba(18,18,16,1);
                    font-size: 18px;
                    font-weight: 400;
                    color:rgba(255,255,255,1);
                    line-height: 52px;
                    outline: none;
                    border: none;
                    cursor: pointer;
                }
            }
        }

        .lawt_parcontent {
            .lawt_cont_title {
                width: 1334px;
                margin: 0 auto;
                position: relative;
                top: 185px;

                div {
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin: auto;
                    z-index: 3;
                    top: 56px;
                    text-align: center;
                    font-size: 30px;
                    font-weight: 400;
                    color: rgba(4, 4, 4, 1);
                    letter-spacing: 3px;
                }

                p {
                    width: 55px;
                    height: 55px;
                    background: rgba(255, 216, 0, 1);
                    border-radius: 50%;
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin: auto;
                    z-index: 2;
                    top: 50px;
                }
            }
        }

        .lawtbo_content {
            width: 1334px;
            margin: 0 auto;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
                width: 667px;
                height: 456px;
            }
        }

        .lawtbo_se_content {
            height: 829px;
            background: rgba(250, 252, 254, 1);

            .lawtbo_se_clt {
                width: 1334px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                height: 100%;

                img {
                    width: 434px;
                    height: 629px;
                }

                .lawbojn {
                    width: 900px;
                    height: 629px;
                    background: rgba(255, 255, 255, 1);
                    box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
                    border-radius: 2px;

                    .lawbojncontent {
                        margin-left: 36px;
                        margin-top: 10px;

                        .lawbojncontent_top {
                            p {
                                height: 36px;
                                font-size: 25px;
                                font-weight: 400;
                                color: rgba(4, 4, 4, 1);
                                line-height: 36px;
                                letter-spacing: 3px;
                            }

                            .commonbottomDiv {
                                width: 193px;
                                height: 25px;
                                background: rgba(216, 216, 216, 1);
                                opacity: 0.15;
                                margin-top: -20px;
                                margin-bottom: 38px;
                            }

                            .show_no_border {
                                border: none !important;
                            }

                            .show_sea_con {
                                border-bottom: 1px solid rgba(238, 238, 238, 1);

                                .show_sea_con_t {
                                    display: flex;
                                    justify-content: flex-start;
                                    padding-top: 20px;
                                    align-items: center;

                                    .show_answer {
                                        width: 23px;
                                        height: 16px;
                                        background: rgba(255, 98, 70, 1);
                                        border-radius: 2px;
                                        font-size: 11px;
                                        font-weight: bold;
                                        color: rgba(255, 255, 255, 1);
                                        -webkit-transform: scale(0.91);
                                        text-align: center;
                                        line-height: 16px;
                                    }

                                    .show_answer_content {
                                        height: 22px;
                                        font-size: 16px;
                                        font-weight: bold;
                                        color: rgba(51, 51, 51, 1);
                                        line-height: 22px;
                                        margin-left: 15px;
                                        max-width: 800px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                }

                                .show_sea_con_b {
                                    display: flex;
                                    justify-content: flex-start;
                                    margin-top: 11px;

                                    .show_question {
                                        width: 27px;
                                        height: 16px;
                                        background: rgba(72, 131, 247, 1);
                                        border-radius: 2px;
                                        font-size: 11px;
                                        -webkit-transform: scale(0.91);
                                        font-weight: bold;
                                        color: rgba(255, 255, 255, 1);
                                        text-align: center;
                                        line-height: 16px;
                                        margin-top: 3px;
                                    }

                                    .show_question_content {
                                        margin-left: 11px;
                                        max-width: 800px;

                                        .show_question_content_t {
                                            font-size: 14px;
                                            font-weight: 400;
                                            color: rgba(102, 102, 102, 1);
                                            line-height: 22px;
                                            display: -webkit-box;
                                            -webkit-box-orient: vertical;
                                            -webkit-line-clamp: 2;
                                            overflow: hidden;
                                            margin-bottom: 17px;
                                        }

                                        .show_question_content_d {
                                            display: flex;
                                            justify-content: space-between;
                                            align-items: center;
                                            margin-top: 5px;

                                            p {
                                                height: 22px;
                                                font-size: 12px;
                                                font-weight: 400;
                                                color: rgba(153, 153, 153, 1);
                                                line-height: 22px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .lawJudgement_three {
            height: 450px;
            background: rgba(250, 252, 254, 1);

            .law_thre_content {
               display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 1334px;
                margin: 0 auto;
                height: 450px;
                overflow: hidden;

                .th_title {
                     width:18px;
                    height:306px;
                    font-size:25px;
                    color:rgba(51,51,51,0.2);
                    line-height:30px;
                }

                img {
                    width: 506px;
                    height: 321px;
                    margin-left: 17px;
                    margin-right: 85px;
                }

                .th_thcontent {
                    height: 321px;

                    img {
                        width: 28px;
                        height: 25px;
                        margin-left: 0px;
                        margin-right: 0px;
                    }

                    .th_pf {
                        height: 28px;
                        font-size: 20px;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        line-height: 28px;
                    }

                    .th_ps {
                        height: 21px;
                        font-size: 15px;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        line-height: 21px;
                    }
                }
            }
        }

        .lawContract_four {
            height:430px;
            background:rgba(255,255,255,1);
            margin-bottom: 80px;
            .lawContract_four_content {
                width: 1334px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-start;
                padding-top: 52px;
                .th_title {
                    width:18px;
                    height:306px;
                    font-size:25px;
                    color:rgba(51,51,51,0.2);
                    line-height:30px;
                }

                .th_thcontent {
                    height: 321px;

                    .tongyong_top {
                        margin-left: 49px;
                        margin-top: 30px;

                        p {
                            height: 36px;
                            font-size: 30px;
                            font-weight: 600;
                            color: #181818;
                            line-height: 36px;
                            letter-spacing: 3px;
                        }

                        div {
                            width:184px;
                            height:25px;
                            background:rgba(216,216,216,1);
                            opacity:0.1592;
                            margin-top: -20px;
                            margin-bottom: 38px;
                            margin-left: -20px;
                        }
                    }

                    .lawContractleft {
                        margin-left: 49px;
                        .span-line{
                            display: inline-block;
                            width:11px;
                            height:1px;
                            background: #E82E31;
                            margin-right: 8px;
                            vertical-align: middle;
                        }
                        p:first-child {
                            height: 28px;
                            font-size: 20px;
                            font-weight: 400;
                            color: rgba(51, 51, 51, 1);
                            line-height: 28px;
                        }

                        p:last-child {
                            width: 330px;
                            height: 21px;
                            font-size: 15px;
                            font-weight: 400;
                            color: rgba(51, 51, 51, 1);
                            line-height: 21px;
                            margin-right: 177px;
                            margin-top: 10px;
                            margin-left: 20px;
                        }
                    }
                }
            }
        }

        .ts_content {
            padding: 30px;

            .ts_content_fr {
                display: flex;
                justify-content: flex-start;

                p {
                    width: 70px;
                    text-align: left;
                    margin-right: 10px;
                    white-space: normal;
                }
            }
        }

        .goOrderEsc {
            margin-top: 20px;
            width: 137px;
            height: 42px;
            background: #121210;
            font-size: 14px;
            font-weight: bold;
            color: #fff;
            line-height: 42px;
            outline: none;
            border: none;
            cursor: pointer;
        }
    }

    .shoetext {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 150px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: inline-block;
        margin-top: 5px;
        margin-left: 10px;
    }
</style>